import { Component, inject } from '@angular/core';
import { AuthService } from 'src/app/core/auth/auth.service';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'adm-not-logged-in',
  templateUrl: './not-logged-in.component.html',
  styleUrls: ['./not-logged-in.component.scss'],
  imports: [MatButtonModule],
})
export class NotLoggedInComponent {
  authService = inject(AuthService);
}
